// extracted by mini-css-extract-plugin
export default {"NavigationLink":"NavigationLink_NavigationLink__OqsmR","Focused":"NavigationLink_Focused__iei4O"};